import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { showSuccess, showError } from "../utils/toast";

const TicketsURL = "https://opensheet.elk.sh/1Nh8T2uQ0Gc2kqsgQzTRFdq4aD36KTD5zOckCDbrJjVA/Tickets";
const ResponsesURL = "https://opensheet.elk.sh/1Nh8T2uQ0Gc2kqsgQzTRFdq4aD36KTD5zOckCDbrJjVA/TicketResponses";
const SubmitResponseURL = "https://script.google.com/macros/s/AKfycbyKu9zN3HMDu3ATvc55wup0Vu05LwVktgVPuV2pcznyyWOQGU7C59NgIU66NxSxC4wKrw/exec";

const TicketDetail = () => {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(null);
  const [responses, setResponses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [responseData, setResponseData] = useState({
    responder: "",
    response: ""
  });

  useEffect(() => {
    fetch(TicketsURL)
      .then(res => res.json())
      .then(rows => setTicket(rows.find(r => r.TicketID === ticketId)));

    fetch(ResponsesURL)
      .then(res => res.json())
      .then(rows => setResponses(rows.filter(r => r.TicketID === ticketId)));
  }, [ticketId]);

  const handleChange = (e) => {
    setResponseData({ ...responseData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    Swal.fire({
      title: "Submitting Response...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    const timestamp = new Date().toLocaleString(); // or use ISO if needed
  
    const formData = new FormData();
    formData.append("action", "addResponse");
    formData.append("ticketId", ticketId);
    formData.append("responder", responseData.responder);
    formData.append("message", responseData.response);
  
    try {
      const res = await fetch(SubmitResponseURL, {
        method: "POST",
        body: formData,
      });
  
      Swal.close(); // Close loading
  
      if (!res.ok) throw new Error("Failed to submit");
  
      showSuccess("Response added!");
      setResponseData({ responder: "", response: "" });
      setShowModal(false);
  
      // Optimistically add to UI without re-fetching
      const newResponse = {
        TicketID: ticketId,
        Timestamp: timestamp,
        Responder: responseData.responder,
        Message: responseData.response,
        InternalNotes: "" // optional field if needed
      };
  
      setResponses((prev) => [...prev, newResponse]);
  
    } catch (err) {
      Swal.close();
      showSuccess("Response added!");
      setShowModal(false);
      console.error(err);
    }
  };
  

  if (!ticket) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4 text-primary fw-bold">Ticket Details</h2>
      <div className="card mb-4">
        <div className="card-body">
          <p><strong>ID:</strong> {ticket.TicketID}</p>
          <p><strong>Date:</strong> {ticket.Timestamp}</p>
          <p><strong>Name:</strong> {ticket.Name}</p>
          <p><strong>Email:</strong> {ticket.Email}</p>
          <p><strong>Subject:</strong> {ticket.Subject}</p>
          <p><strong>Message:</strong> {ticket.Message}</p>
          <p><strong>Status:</strong> 
            <span className={`badge ms-2 ${
              ticket.Status === "Pending" ? "bg-warning text-dark" : "bg-success"
            }`}>{ticket.Status}</span>
          </p>
        </div>
      </div>

      <h4 className="mb-3">Responses</h4>
      {responses.length === 0 ? (
        <div className="alert alert-secondary">No responses yet.</div>
      ) : (
        <ul className="list-group mb-4">
          {responses.map((r, idx) => (
            <li key={idx} className="list-group-item">
              <div className="fw-bold">{r.Responder} <small className="text-muted">({r.Timestamp})</small></div>
              <div>{r.Message}</div>
            </li>
          ))}
        </ul>
      )}

      <button className="btn btn-primary" onClick={() => setShowModal(true)}>
        Add Response
      </button>

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Response</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Responder</label>
                  <input
                    name="responder"
                    value={responseData.responder}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    placeholder="Your name"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Response</label>
                  <textarea
                    name="response"
                    value={responseData.response}
                    onChange={handleChange}
                    className="form-control"
                    rows="3"
                    placeholder="Write your response..."
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketDetail;
